import { AppThunk } from '../../../store/rootReducer';
import { getBaseProperties, track } from '../analytics.utils';
import { SELECT_DIAGNOSTIC } from '../analytics.constants';

export const trackSelectDiagnostic =
  (expertId: string | null, analyticsTrack = track): AppThunk =>
  (_, getState) => {
    const baseProperties = getBaseProperties(getState);
    if (baseProperties == null) {
      return null;
    }
    const { ecgId, userId, view } = baseProperties;

    analyticsTrack({
      name: SELECT_DIAGNOSTIC,
      properties: {
        user_id: userId,
        view,
        ecg_id: ecgId,
        displayed_diagnosis: expertId ?? 'diagnostic_from_algorithm',
      },
    });
  };
